import Typography from "@mui/material/Typography";

import * as Constants from "../../config/constants/Constants.js";
import { getLanguage } from "../../config/language/language.js";

export default function Copyright() {
    return (
        <Typography variant="body2" color="text.secondary" align="center" sx={{ pt: 4, pb: 4 }}
                    style={{ whiteSpace: "pre-line" }}>
            {getLanguage().COPYRIGHT} {new Date().getFullYear()}
            {".\n"}
            {Constants.VERSION}
        </Typography>
    );
}
